export const workspaceKeys = {
  all: ['workspace'] as const,
  capabilities: ['workspace', 'capabilities'] as const,
  tenants: ['workspace', 'tenants'] as const,
  projects: (search: string, limit: number) => ['workspace', 'projects', search, limit] as const,
  project: (projectId: string) => ['workspace', 'project', projectId] as const,
  members: (projectId: string) => ['workspace', 'members', projectId] as const,
  summary: (projectId: string) => ['workspace', 'summary', projectId] as const,
  health: (projectId: string) => ['workspace', 'health', projectId] as const,
};
